module.exports = __webpack_public_path__ + "img/masad.e8d59f61.jpg";